module.exports = __webpack_public_path__ + "img/81ad684.webp";